import React, { useEffect, useState } from "react"

import dayjs from "src/dayjs"

import Countdown from "components/Countdown"

export type SessionTimerProps = {
  startsAt: string
  endsAt: string
}

type SessionState = "future" | "current" | "past"

const getSessionState = (startsAt: string, endsAt: string): SessionState => {
  const now = dayjs()
  if (dayjs(startsAt).isAfter(now)) return "future"
  else if (dayjs(endsAt).isAfter(now)) return "current"
  else return "past"
}

const SessionTimer: React.FC<SessionTimerProps> = ({ startsAt, endsAt }) => {
  const [sessionState, setSessionState] = useState<SessionState>(
    getSessionState(startsAt, endsAt)
  )

  useEffect(() => {
    const startTimeout = setTimeout(() => {
      setSessionState(getSessionState(startsAt, endsAt))
    }, dayjs(startsAt).diff(dayjs(), "milliseconds") + 500)

    const endTimeout = setTimeout(() => {
      setSessionState(getSessionState(startsAt, endsAt))
    }, dayjs(endsAt).diff(dayjs(), "milliseconds") + 500)

    return () => {
      clearTimeout(startTimeout)
      clearTimeout(endTimeout)
    }
  }, [startsAt, endsAt])

  return (
    <div className="mb-1 flex justify-center text-xl font-medium tracking-wide">
      {sessionState === "future" ? (
        <span className="text-sky-400">
          Session starts in {<Countdown timestamp={startsAt} />}
        </span>
      ) : sessionState === "current" ? (
        <span className="text-gray-400">
          Session ends in {<Countdown timestamp={endsAt} />}
        </span>
      ) : sessionState === "past" ? (
        <span className="text-red-400">Scheduled time is complete.</span>
      ) : null}
    </div>
  )
}

export default SessionTimer
